import { css } from 'styled-components';

const appBreakpoints = {
  mn1: 320,
  mn: 425,
  sm: 768,
  md: 960,
  lg: 1280,
  xl: 1920,
  switchFooterToDesktop: 500,
  switchHeaderToDesktop: 768,
};

/**
 * breakpoints helpers for styled components in web
 * @example ${media.md`background: black;` }
 */
export const media = Object.keys(appBreakpoints).reduce((acc, label) => {
  acc[label] = (...args) => css`
      @media (min-width: ${appBreakpoints[label]}px) {
        ${css(...args)};
      }
    `;

  return acc;
}, {});

/**
 * helper to truncate a text at certain width in web
 * @param {number} width - width limit
 * @returns {func}
 */
export function truncate(width) {
  return css`
    width: ${width}px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `;
}

/**
 * Helper to convert px to rem units with styled components
 * @example font-size: ${rem(15)}; or font-size: ${rem('15px')};
 * @example font-size @{rem`15`};
 * @param {number|string} number - number in px to convert
 * @param {number} [base = 16] - base
 * @returns {string}
 */
export function rem(number, base = 16) {
  return `${parseFloat(number) / base}rem`;
}
